module.exports = __webpack_public_path__ + "static/mstile-310x310-02c3f217df89528a47b4aded941e689d.png";